<template>
    <div>
        <div class="mb-1">
            <label class="form-label">{{backgroundType}} Background</label>
            <select class="form-select" aria-label="Select header font" v-model="background.type">
                <option>solid</option>
                <option>linear gradient</option>
                <option>radial gradient</option>
            </select>
        </div>

        <div class="mb-1 d-flex align-items-center">
            <div class="me-2">Color</div>
            <color-picker :color-object="background" color-field="background_color" class="mt-1"></color-picker>

            <div v-if="background.type !== 'solid'" class="mx-2">2nd Color</div>
            <color-picker v-if="background.type !== 'solid'" :color-object="background" color-field="background_color2"
                          class="mt-1"></color-picker>

            <div class="mx-2">Text</div>
            <color-picker :color-object="background" color-field="color" class="mt-1"></color-picker>
        </div>

    </div>
</template>

<script>
import ColorPicker from "../components/ColorPicker.vue";
export default {
    name: 'BackgroundEditor',
    components: {ColorPicker},
    props: ['background', 'backgroundType'],
    data () {
        return {
            model: webase.model
        }
    }
}
</script>

<style>

</style>
